// extracted by mini-css-extract-plugin
export default {"app":"sehq3","app-store":"HIiko","app-phone":"D0pOo"};